import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// @mui
import { Autocomplete, Popover, Button, Stack, TextField, Container, FormControlLabel, Checkbox } from '@mui/material';

import { getGenericData, getUsuarios, getFornecedores } from './api';
import { useUnidades } from '../hooks/useUnidades';

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const PopoverFiltroOs = React.forwardRef((props, ref) => {
  const [filtro, setFiltro] = useState(props.filtro);
  const { unidades } = useUnidades();
  const [filterOptions, setFilterOptions] = useState({
    classificacoes: [],
    responsaveis: [],
    fornecedores: [],
    distribuidoras: [],
  });

  // Carrega os fluxos e as opções dos filtros na montagem
  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const [classificacoes, usuarios, fornecedores, distribuidoras] = await Promise.all([
          getGenericData('classificacao'),
          getUsuarios(),
          getFornecedores(),
          getGenericData('distribuidora'),
        ]);

        setFilterOptions({
          classificacoes,
          responsaveis: usuarios.filter((u) => u.ativo), // Apenas ativos
          fornecedores,
          distribuidoras,
        });
      } catch (error) {
        console.error('Erro ao carregar dados iniciais do Kanban:', error);
        alert('Erro ao carregar dados do Kanban.');
      }
    };
    loadInitialData();
  }, []);

  // Calendario
  const handleDateChange = (e) => {
    setFiltro((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Handlers de Filtro
  const handleMultiSelectChange = (filterKey, value) => {
    setFiltro((prev) => ({
      ...prev,
      [filterKey]: prev[filterKey].includes(value)
        ? prev[filterKey].filter((item) => item !== value) // Remove
        : [...prev[filterKey], value], // Adiciona
    }));
  };

  const handleConfirm = () => {
    props.onConfirm(filtro);
  };
  return (
    <Popover
      open={Boolean(props.open)}
      anchorEl={props.open}
      onClose={props.onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          width: 'auto+10',
          height: '100%',
          flex: 1,
          display: 'flex',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        },
      }}
    >
      <Stack flex={1} gap={1} sx={{ height: 'auto' }}>
        {
          props.type !== 'cronograma' &&
          <Stack direction={'row'} gap={2}>
          <TextField
            name="dataInicio"
            type="date"
            value={filtro.dataInicio}
            onChange={handleDateChange}
            InputLabelProps={{ shrink: true }}
            style={{ marginRight: 10 }}
          />
          <TextField
            name="dataFim"
            type="date"
            value={filtro.dataFim}
            onChange={handleDateChange}
            InputLabelProps={{ shrink: true }}
            style={{ marginRight: 10 }}
          />
        </Stack>
        }
        
        {
          props.type === 'cronograma' &&
          <Stack direction={'row'} gap={2}>
          <TextField
            name="dataAgendamentoInicio"
            type="date"
            value={filtro.dataAgendamentoInicio}
            onChange={handleDateChange}
            InputLabelProps={{ shrink: true }}
            style={{ marginRight: 10 }}
          />
          <TextField
            name="dataAgendamentoFim"
            type="date"
            value={filtro.dataAgendamentoFim}
            onChange={handleDateChange}
            InputLabelProps={{ shrink: true }}
            style={{ marginRight: 10 }}
          />
        </Stack>
        }

        <div className="filter-group">
          <strong className="filter-group-label">Unidade</strong>
          <div className="checkbox-list">
            {unidades.map((opt) => (
              <FormControlLabel
                key={opt._id}
                control={
                  <Checkbox
                    size="small"
                    checked={filtro.unidades.includes(opt._id)}
                    onChange={() => handleMultiSelectChange('unidades', opt._id)}
                  />
                }
                label={opt.nome}
              />
            ))}
          </div>
        </div>

        {/* Classificacao */}
        <div className="filter-group">
          <strong className="filter-group-label">Classificação</strong>
          <div className="checkbox-list">
            {filterOptions.classificacoes.map((opt) => (
              <FormControlLabel
                key={opt._id}
                control={
                  <Checkbox
                    size="small"
                    checked={filtro.classificacoes.includes(opt._id)}
                    onChange={() => handleMultiSelectChange('classificacoes', opt._id)}
                  />
                }
                label={opt.nome}
              />
            ))}
          </div>
        </div>
        {/* Responsável */}
        <div className="filter-group">
          <strong className="filter-group-label">Responsável</strong>
          <div className="checkbox-list">
            {filterOptions.responsaveis.map((opt) => (
              <FormControlLabel
                key={opt._id}
                control={
                  <Checkbox
                    size="small"
                    checked={filtro.responsaveis.includes(opt._id)}
                    onChange={() => handleMultiSelectChange('responsaveis', opt._id)}
                  />
                }
                label={opt.nome}
              />
            ))}
          </div>
        </div>
        {/* Fornecedor */}
        <div className="filter-group">
          <strong className="filter-group-label">Fornecedor</strong>
          <div className="checkbox-list">
            {filterOptions.fornecedores.map((opt) => (
              <FormControlLabel
                key={opt._id}
                control={
                  <Checkbox
                    size="small"
                    checked={filtro.fornecedores.includes(opt._id)}
                    onChange={() => handleMultiSelectChange('fornecedores', opt._id)}
                  />
                }
                label={opt.nome}
              />
            ))}
          </div>
        </div>
        {/* Distribuidora */}
        <div className="filter-group">
          <strong className="filter-group-label">Distribuidora</strong>
          <div className="checkbox-list">
            {filterOptions.distribuidoras.map((opt) => (
              <FormControlLabel
                key={opt._id}
                control={
                  <Checkbox
                    size="small"
                    checked={filtro.distribuidoras.includes(opt._id)}
                    onChange={() => handleMultiSelectChange('distribuidoras', opt._id)}
                  />
                }
                label={opt.nome}
              />
            ))}
          </div>
        </div>

        <Container sx={{ marginTop: 2 }}>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Button variant={'outlined'} onClick={props.onLimpar}>
              Limpar
            </Button>

            <Button variant={'contained'} color={'success'} onClick={handleConfirm}>
              Filtrar
            </Button>
          </Stack>
        </Container>
      </Stack>
    </Popover>
  );
});

PopoverFiltroOs.propTypes = {
  open: PropTypes.object,
  onClose: PropTypes.func,
  onLimpar: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default PopoverFiltroOs;